(function(){
  /* Strip redundant Specs tables + headings from Full Description
     (the Technical Specifications card already shows the same data). */
  document.querySelectorAll('.tu-pdp-description--enhanced').forEach(function(desc){
    desc.querySelectorAll('table').forEach(function(t){ t.style.display = 'none'; });
    desc.querySelectorAll('h2, h3, h4, h5, h6, p, div').forEach(function(el){
      var txt = (el.textContent || '').trim().toLowerCase().replace(/[:\s]+$/, '');
      if (txt === 'specs' || txt === 'specifications' || txt === 'technical specifications') {
        el.style.display = 'none';
      }
    });
  });

  /* Gallery */
  var main = document.getElementById('tuMainProductImg');
  var thumbs = document.querySelectorAll('.tu-pdp-thumb');
  var prev = document.getElementById('tuGalleryPrev');
  var next = document.getElementById('tuGalleryNext');
  var idx = 0;
  function setImg(i){
    if (!thumbs.length) return;
    idx = (i + thumbs.length) % thumbs.length;
    var src = thumbs[idx].getAttribute('data-full-src');
    if (main && src) main.src = src;
    thumbs.forEach(function(t,j){ t.classList.toggle('active', j === idx); });
  }
  thumbs.forEach(function(t,j){ t.addEventListener('click', function(){ setImg(j); }); });
  if (prev) prev.addEventListener('click', function(){ setImg(idx - 1); });
  if (next) next.addEventListener('click', function(){ setImg(idx + 1); });

  /* Variants */
  var productJson = window.turonicProduct;
  var variantBtns = document.querySelectorAll('.tu-variant-btn');
  var selectedOptions = [];
  productJson.options.forEach(function(_,i){ selectedOptions[i] = productJson.options_with_values ? null : null; });
  /* Initialize from current */
  var current = window.turonicCurrentVariant;
  if (current && current.options) selectedOptions = current.options.slice();

  function findVariant(){
    return productJson.variants.find(function(v){
      return v.options.every(function(opt, i){ return opt === selectedOptions[i]; });
    });
  }
  function updateVariant(){
    var v = findVariant();
    if (!v) return;
    document.getElementById('tuVariantId').value = v.id;
    var priceEl = document.getElementById('tuPdpPriceCurrent');
    var compEl = document.getElementById('tuPdpPriceCompare');
    if (priceEl) priceEl.textContent = (v.price/100).toLocaleString('en-US',{style:'currency',currency:'' + window.turonicCurrency + ''});
    if (compEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compEl.textContent = (v.compare_at_price/100).toLocaleString('en-US',{style:'currency',currency:'' + window.turonicCurrency + ''});
        compEl.style.display = '';
      } else { compEl.style.display = 'none'; }
    }
    var atc = document.getElementById('tuAddToCart');
    if (atc) {
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to Cart →' : 'Sold Out';
    }
  }
  variantBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      var pos = parseInt(btn.getAttribute('data-option-position'),10) - 1;
      var val = btn.getAttribute('data-option-value');
      selectedOptions[pos] = val;
      variantBtns.forEach(function(b){
        if (parseInt(b.getAttribute('data-option-position'),10) - 1 === pos) {
          b.classList.toggle('tu-variant-active', b.getAttribute('data-option-value') === val);
        }
      });
      updateVariant();
    });
  });
})();